import { render, staticRenderFns } from "./KtbFastPayCancel.vue?vue&type=template&id=024d4162&scoped=true"
import script from "./KtbFastPayCancel.vue?vue&type=script&lang=js"
export * from "./KtbFastPayCancel.vue?vue&type=script&lang=js"
import style0 from "./KtbFastPayCancel.vue?vue&type=style&index=0&id=024d4162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d4162",
  null
  
)

export default component.exports